import React from 'react';

const Index = () => {
  return (
    <footer>
      <p>created by <a href="https://github.com/Muhammadrizo14">@ubuntuous</a></p>
    </footer>
  );
};

export default Index;